import { useMemo } from 'react';

import { useGetMeetingMedia } from '@/api/generated';

const useMeetingMedia = (botId: string | undefined) => {
  const { data: transcriptResponse, isLoading: transcriptLoading } = useGetMeetingMedia(
    botId!,
    { type: 'transcript' },
    {
      query: {
        queryKey: ['geMeetingTranscript', botId],
        enabled: !!botId,
        refetchOnWindowFocus: false
      }
    }
  );

  const { data: recordingResponse, isLoading: recordingLoading } = useGetMeetingMedia(
    botId!,
    { type: 'recording' },
    {
      query: {
        queryKey: ['getMeetingRecording', botId],
        enabled: !!botId,
        refetchOnWindowFocus: false
      }
    }
  );

  const meetingTranscriptUrl = useMemo(
    () => transcriptResponse?.items?.[0]?.url || '',
    [transcriptResponse?.items]
  );

  const meetingRecordingUrl = useMemo(
    () => recordingResponse?.items?.[0]?.url || '',
    [recordingResponse?.items]
  );

  return {
    meetingTranscriptUrl,
    meetingRecordingUrl,
    transcriptLoading,
    recordingLoading
  };
};

export default useMeetingMedia;
